import { useGetExternalReportData } from 'hooks/ExternalReport/useGetExternalReportData';

const ExternalReportPage = () => {
  const { data: externalReportData, isLoading, isError, error } = useGetExternalReportData();

  if (isLoading) return <h1>Loading...</h1>;

  if (isError) {
    const status = (error as any)?.response?.status;

    if (status === 401 || status === 403) {
      return (
        <div>
          <h1>⏱️ Session Expired</h1>
          <p>Your reports session has expired. Please request access again from the application that send you here.</p>
          <button onClick={() => window.close()}>Close Tab</button>
        </div>
      );
    }

    return (
      <div>
        <h1>Error accessing report</h1>
        <p>Please request access again from the application that send you here or contact support.</p>
        <button onClick={() => window.close()}>Close Tab</button>
      </div>
    );
  }

  if (!externalReportData) return <h1>No data available</h1>;

  return (
    <div>
      <h1>Player Id: {externalReportData.playerId}</h1>
      <h1>Event Id: {externalReportData.eventId}</h1>
      <h1>Report Type: {externalReportData.reportType}</h1>
    </div>
  );
};

export default ExternalReportPage;
